import i18next from 'i18next';

/**
 * API相关常量
 */

// API状态码
export const API_CODE = {
  SUCCESS: 200,
  SUCCESS_ZERO: 0, // 一些API成功状态码为0
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

// API请求超时时间
export const API_TIMEOUT = 15000;

// API请求基础URL
export const API_BASE_URL = (import.meta as any).env.VITE_APP_BASE_API || '/api';

// 短信相关错误码
export const SMS_ERROR_CODE = {
  LIMIT_MOBILE_DAILY: 600003, // 手机号发送短信次数超出限制
  LIMIT_IP_DAILY: 600004, // IP发送短信次数超出限制
  SEND_FAILED: 600005, // 发送短信失败
  INVALID_SMS_CODE: 600006, // 验证码错误
  SMS_NOT_REQUESTED: 600007, // 未获取验证码
  CODE_MUST_FILL_MOBILE: 600008, // 必须填写手机号
  CODE_MOBILE_ALREADY_EXISTS: 600009, // 手机号已绑定其他用户
} as const;

// API错误消息
export const API_ERROR_MESSAGES = {
  NETWORK_ERROR: i18next.t('error.networkError'),
  REQUEST_TIMEOUT: i18next.t('error.requestTimeout2'),
  SERVER_ERROR: i18next.t('error.serverError2'),
  UNKNOWN_ERROR: i18next.t('error.unknownError'),
  // 短信相关错误消息
  [SMS_ERROR_CODE.LIMIT_MOBILE_DAILY]: i18next.t('error.smsLimitMobileDaily'),
  [SMS_ERROR_CODE.LIMIT_IP_DAILY]: i18next.t('error.smsLimitIpDaily'),
  [SMS_ERROR_CODE.SEND_FAILED]: i18next.t('error.smsSendFailed'),
  [SMS_ERROR_CODE.INVALID_SMS_CODE]: i18next.t('error.smsInvalidCode'),
  [SMS_ERROR_CODE.SMS_NOT_REQUESTED]: i18next.t('error.smsNotRequested'),
  [SMS_ERROR_CODE.CODE_MUST_FILL_MOBILE]: i18next.t('error.smsMustFillMobile'),
  [SMS_ERROR_CODE.CODE_MOBILE_ALREADY_EXISTS]: i18next.t('error.smsMobileAlreadyExists'),
};
